import { GetComponentStyleFunc } from './types';

export const muiRadio: GetComponentStyleFunc<'MuiRadio'> = theme => {
  return {
    styleOverrides: {
      root: {
        padding: '8px',
        color: theme.colors.functional.text.lint,
        '&.Mui-checked': {
          color: theme.colors.schema.primary,
        },
        '& > span > svg.MuiSvgIcon-root': {
          width: '20px',
          height: '20px',
        },
      },
    },
  };
};
